const setOfferSessionClosed = () => {
  sessionStorage.setItem('offerModalClosed', 1);
};

function OfferPopup () {
    
  let OfferPopupSelector = document.querySelector('.offerModal');

  if (!sessionStorage.getItem('offerModalClosed')) {
    OfferPopupSelector.classList.add('offerModal__overlay--active');
  }

  let OfferPopupClose = document.querySelector('.offerModal__close');

  OfferPopupClose.addEventListener('click', (e) => {
    e.preventDefault();
    setOfferSessionClosed();
    OfferPopupSelector.classList.remove('offerModal__overlay--active');
  });

}

export default OfferPopup;


// WEBPACK FOOTER //
// ./src/js/app/components/OfferPopup.js